import(/* webpackMode: "eager" */ "/app/app/(front)/layout.tsx");
